<template>
  <div>
    <Modal title="修改费率" v-model="visible" width="700" class="my-modal top edit-rate-wrap" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" class="page-form less" :label-width="110">
        <FormItem label="保单编号">
          <span>{{ formData.policyNo }}</span>
        </FormItem>

        <FormItem label="保单状态">
          <span>{{ POLICY_STATUS[formData.policyStatus] }}</span>
        </FormItem>

        <FormItem label="保单期数">
          <span>{{ formData.commissionIndex }}</span>
        </FormItem>

        <FormItem label="供应商">
          <span>{{ SUPPLIERS[formData.suppliers] }}</span>
        </FormItem>

        <FormItem label="保险公司">
          <span>{{ formData.companyName }}</span>
        </FormItem>

        <FormItem label="产品名称">
          <span>{{ formData.productName }}</span>
        </FormItem>

        <FormItem label="冷静期截止日">
          <span>{{ filterTime(formData.expirationDate, 'YYYY-MM-DD') }}</span>
        </FormItem>

        <FormItem label="受保人年龄">
          <span>{{ formData.insuranceAge }}</span>
        </FormItem>

        <FormItem label="年缴保费">
          <span
            >{{ formData.fee }}{{ CURRENCY_TYPE[formData.currencyType] }}/{{ formData.paymentPeriod }}
            <template v-if="formData.paymentType">{{ GUARANTEE_TYPE[formData.paymentType] }}</template
            ><template v-else>年</template></span
          >
        </FormItem>

        <FormItem label="签单代理人">
          <span>{{ formData.agentStaffNo }}/{{ formData.agentName }}/{{ ifaLevelMap[formData.ifaLevel] }}</span>
        </FormItem>

        <FormItem label="佣金项类型">
          <span>{{ commissionTypeMap[formData.commissionType] }}</span>
        </FormItem>
        <FormItem prop="newCommission" label="修改后佣金率" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.newCommission" placeholder="请输入">
            <span slot="append">%</span>
          </Input>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import { filterTime } from '@/api/filter';
const dic = JSON.parse(localStorage.dic);
const POLICY_STATUS = dic['POLICY_STATUS'];
const SUPPLIERS = dic['SUPPLIERS'];
const CURRENCY_TYPE = dic['CURRENCY_TYPE'];
const GUARANTEE_TYPE = dic['GUARANTEE_TYPE'];

export default {
  mixins: [common],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      POLICY_STATUS,
      SUPPLIERS,
      CURRENCY_TYPE,
      GUARANTEE_TYPE,
      ifaLevelMap: {
        0: '',
        1: '萌新',
        2: '新贵',
        3: '精英',
        4: '王者'
      },
      commissionTypeMap: {
        1: '基础销售佣金',
        11: '个人Bonus',
        12: '管理津贴',
        13: '推荐奖',
        14: '辅导奖',
        15: '育成奖',
        16: '育成奖'
      },
      formData: {
        id: '',
        policyNo: '',
        policyStatus: '',
        commissionIndex: '',
        suppliers: '',
        companyName: '',
        productName: '',
        expirationDate: '',
        insuranceAge: '',
        fee: '',
        currencyType: '',
        paymentPeriod: '',
        paymentType: '',
        agentStaffNo: '',
        agentName: '',
        ifaLevel: '',
        commissionType: '',
        commission: '',
        newCommission: ''
      }
    };
  },
  methods: {
    filterTime,
    open(data) {
      this.visible = true;
      this.loading = false;
      data = JSON.parse(JSON.stringify(data));
      this.formData = {
        ...data,
        newCommission: data.commission || ''
      };
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;

        this.$http({
          type: 'POST',
          url: '/buz/ifaSettlementReport/updateReferralCommissionRate',
          data: {
            settlementLogId: this.formData.id,
            newCommissionRate: this.formData.newCommission
          }
        })
          .then(res => {
            this.visible = false;
            this.loading = false;
            this.$notice.success('操作成功');
            this.$emit('success');
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-rate-wrap {
  /deep/ .ivu-form-item-label {
    &::after {
      content: ':';
    }
  }
}
</style>
